<template>
	<div class="row">
		<div class="col-md-12">
			<section class="panel">
        <ul class="nav nav-tabs" role="tablist">
          <li class="active" role="presentation">
            <a data-toggle="tab">設定開放時間</a>
          </li>
          <li>
            <router-link :to="{name:'relief.treaty'} ">設定隱私權宣告</router-link>
          </li>
        </ul>
				<header class="panel-heading">
					<h2 class="panel-title">設定開放時間</h2>
				</header>
				<div class="panel-body container-fluid">
                    <div class="row form-group">
						<div class="col-md-12 form-group">
							<label for="smtr" class="column-required">作業學期 : </label>
                            <input type="text" class="form-control" v-validate="'required'" v-model="form.smtr" name="smtr" id="smtr" :style="{width:'auto', display:'inline-block'}"/>
                            <span>(例109年第一學期 即輸入1091)</span>
						</div>
						<div class="col-md-12 form-group">
							<label class="column-required">開放時間 : </label>
                            <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.startDate" name="startDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" /> ~
                            <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.endDate" name="endDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" />
						</div>
                    </div>
					<div class="row form-group">
						<div class="col-md-12">
							<div class="col-md-2 "></div>
							<div class="col-md-2 col-xs-3"></div>
							<div class="col-md-2 col-xs-3">
								<button @click="handleCancel" class="btn btn-default btn-block">取消</button>
							</div>
							<div class="col-md-2 col-xs-3">
								<button @click="handleSave" class="btn btn-primary btn-block">儲存</button>
							</div>
							<div class="col-md-2 col-xs-3"></div>
							<div class="col-md-2 "></div>
						</div>
					</div>
				</div>

			</section>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
                smtr: "",
                startDate: null,
                endDate: null
            }
		}
	},
	created() {
		const api = "/api/systemsetting?key=ReliefTimeSetting"
		this.$axios.get(api).then(resp => {
			this.form = JSON.parse(resp.data.data.value)
		});
	},
	updated() {
	},
	methods: {
		handleCancel() {
			this.$router.go(-1)
		},
		handleSave() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const api = "/api/systemsetting";
                    const body = {
                        "key": "ReliefTimeSetting",
                        "value": JSON.stringify(this.form)
                    }
					this.$axios.post(api, body).then(resp => {
						if (resp.data.status === "success") {
                            this.$router.push({ name: 'relief.list' })
						} else {
							bootbox.alert(resp.data.msg)
						}
					});
				} else {
					bootbox.alert("請確認必填欄位是否有填寫")
				}
			});

		}
	},
	computed:{
	}
}
</script>

<style scoped>
</style>
